<script setup lang="ts">
import { DialogDescription } from "reka-ui";
</script>

<template>
  <DialogDescription class="text-pretty text-slate-500">
    <slot />
  </DialogDescription>
</template>
